// src/utils/helpFeedback.ts
//
// Where the sidebar's "Help & Feedback" button sends people. It used to open
// the Freshdesk widget; since 2026-10-14 it opens an email to ScheduleHero
// support instead.
//
// White-label sub-accounts never had a support widget (their partner is their
// support), and they must not see a ScheduleHero address, so they get no
// button at all. While a sub-account's partner type is still loading we also
// return null, so the address never flashes up for a white-label client.

import { CONTACT_EMAIL } from '../lib/contact-email';

export const HELP_FEEDBACK_EMAIL = CONTACT_EMAIL;

export const HELP_FEEDBACK_MAILTO =
  `mailto:${HELP_FEEDBACK_EMAIL}?subject=${encodeURIComponent('Help & Feedback')}`;

export function getHelpFeedbackHref(args: {
  userType: string | null | undefined;
  partnerId: string | null | undefined;
  // Partner type of the account's partner (sub-accounts) or of the account
  // itself (partners); undefined while it is still loading.
  partnerType: string | null | undefined;
}): string | null {
  const isSubAccount = args.userType === 'partner_client' && !!args.partnerId;
  if (isSubAccount && args.partnerType !== 'co_branded') return null;
  return HELP_FEEDBACK_MAILTO;
}
